@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.heroImage {
  width: 100%;
  height: auto;
}

.modalContent {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.modalText {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.buttons {
  display: flex;
  gap: 8px;

  @include for-phone-only {
    flex-direction: column;
  }
}
